import { createFileRoute } from '@tanstack/react-router'
import DormitoryV2Page  from '@/features/dormitory-v2'

export const Route = createFileRoute('/_authenticated/dormitory-hierachy/')({
  component: DormitoryV2Page,
})